import api from './api';
import type {
  FuenteAlimentacionDto,
  FuenteAlimentacionCreateRequest,
} from '@/types/fuente';

export const fuentesApi = {
  findAll: () =>
    api.get<FuenteAlimentacionDto[]>('/fuentes').then((r) => r.data),

  findById: (id: number) =>
    api.get<FuenteAlimentacionDto>(`/fuentes/${id}`).then((r) => r.data),

  create: (data: FuenteAlimentacionCreateRequest) =>
    api.post<FuenteAlimentacionDto>('/fuentes', data).then((r) => r.data),

  update: (id: number, data: FuenteAlimentacionCreateRequest) =>
    api.put<FuenteAlimentacionDto>(`/fuentes/${id}`, data).then((r) => r.data),

  uploadImage: (id: number, formData: FormData) =>
    api
      .post<FuenteAlimentacionDto>(`/fuentes/${id}/imagen`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data),

  delete: (id: number) => api.delete(`/fuentes/${id}`),
};
